import { Directive, Inject, Input } from '@angular/core';
import { MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { CustomDateFormat } from '../../../models/field/custom-date-formats.model';


@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[dateFormats]',
    providers: [
        {
            provide: MAT_DATE_FORMATS,
            useClass: CustomDateFormat
        }
    ]
})
export class GenericDateFormatDirective {
    @Input()
    public set dateFormats(format: MatDateFormats) {
        this.matDateFormat.value = format;
    }

    constructor(
        @Inject(MAT_DATE_FORMATS) public matDateFormat: CustomDateFormat,
    ) {
    }
}
